// The API this build talks to. Every build should set REACT_APP_API_URL (dev: .env; live: its own .env), and
// `npm run build` refuses to run without it (scripts/check-build-env.js). If a build is made some other way with the
// variable unset, it falls back to the DEV API, never the live one (ENV-1, 2026-10-20: worktree builds without a .env
// were sending requests to api.heliconflow.app).
export const API_BASE = process.env.REACT_APP_API_URL || 'https://dev-api.heliconflow.app';
